import React, { ReactNode } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from "@mui/material";
import pageStyles from "../../pages/pageStyles";
import { Delete, ExpandMore, Payment } from "@mui/icons-material";

interface ListItemProps<T> {
  item: T;
  index: number;
  onRemove?: (item: T, index: number) => void;
  children?: ReactNode;
}

const ListItem = <T extends object>({
  item,
  index,
  onRemove,
  children,
}: ListItemProps<T>) => {
  const styles = pageStyles();

  return (
    <Accordion className={styles.Accordion}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box className={styles.processorTitleWrapper}>
          <Typography className={styles.processorTitle}>
            <Payment style={{ marginRight: "5px" }} />
            {`Bin ${index + 1}`}
          </Typography>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              if (onRemove instanceof Function) {
                onRemove(item, index);
              }
            }}
            size="small"
            startIcon={<Delete />}
          >
            Delete
          </Button>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        style={{
          background: "var(--dmg-bg)",
          borderTop: "1px solid var(--dmg-gray-200)",
          padding: "16px",
          marginTop: "8px",
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default ListItem;
